import { render } from "./UploadCloud.vue?vue&type=template&id=14bc18b6&scoped=true"
import script from "./UploadCloud.vue?vue&type=script&lang=js"
export * from "./UploadCloud.vue?vue&type=script&lang=js"

import "./UploadCloud.vue?vue&type=style&index=0&id=14bc18b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14bc18b6"]])

export default __exports__